import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum CalendarCheckoutTypeEnum {
    ALL_DAY = 'allDay',
    PARTIAL = 'partial',
}

export const calendarCheckoutTypeEnumOptions = enumToOptions(
    CalendarCheckoutTypeEnum,
    'calendar.checkout.types.',
);
